var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"analytics-kabayan-page"}},[(_vm.topics)?_c('page-header-component',{staticClass:"m-b-10",attrs:{"topics":_vm.topics,"title":"Analytics"},on:{"pageHeaderLoaded":_vm.pageHeaderLoaded}}):_vm._e(),(_vm.show_body)?_c('tab-medsos-component'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }